import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/http/api.service';

@Injectable({
  providedIn: 'root',
})
export class OtpSmsService {
  constructor(private http: ApiService) {}

  send(data?: any, header?: any): any {
    return this.http.post(`/api/sms-otp/send/`, data, header);
  }

  verify(data: any): any {
    return this.http.post(`/api/sms-otp/verify/`, data);
  }

  close(data: any): any {
    return this.http.post(`/api/sms-otp/close/`, data);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContractOtpSmsService {
  constructor(private http: ApiService) {}

  send(data?: any, header?: any) {
    const memoId = data?.memo_id;
    if (memoId) {
      return this.sendSmsOtp(memoId, data, header);
    }

    const memos = data?.memos;
    if (memos) {
      return this.sendSmsOtpForMultiAction(data, header);
    }

    throw new Error('memo id is required');
  }

  sendSmsOtp(memoId: any, data?: any, header?: any) {
    return this.http.post(
      `/api/memos/contract/${memoId}/sms-otp/`,
      data,
      header,
    );
  }

  sendSmsOtpForMultiAction(data?: any, header?: any) {
    return this.http.post(
      `/api/memos/contract/multi-action-sms-otp/`,
      data,
      header,
    );
  }
}
